import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function SignupSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get the parameters from the URL
    const data = {
      waba_id: searchParams.get('waba_id'),
      phone_number_id: searchParams.get('phone_number_id'),
      business_id: searchParams.get('business_id'),
      access_token: searchParams.get('access_token')
    };

    // Send message to parent window
    if (window.opener) {
      window.opener.postMessage(JSON.stringify({
        type: 'whatsapp_business_setup_complete',
        ...data
      }), '*');
      window.close();
    } else {
      // If no opener, redirect back to connect page
      navigate('/connect-whatsapp');
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#25D366] mx-auto mb-4" />
        <p className="text-gray-600">Completando la configuración...</p>
      </div>
    </div>
  );
}